<template>
	<ProcessCreatePage>
		<Header :title="$t('new_comprehensive_repair_order').toString()"></Header>

		<div class="main">
			<default-or-value-form ref="form" v-model="model" :default-value="defaultValue" placeholder="Auftragstext" @changeRadio="warn">
				<template #default>
					<label>{{ $t('prepared_oder_text') }}<br /></label>
					<span class="font-semibold">{{ defaultValue }}</span>
				</template>
				<template #custom>
					<p>{{ $t('individual_oder_text') }}<br /></p>
				</template>
			</default-or-value-form>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick(false)"
			@skipButtonClick="continueButtonClick(true)"
			:is-skippable="false"
			:is-back-button="true"
		/>
	</ProcessCreatePage>
</template>

<script>
import AppContainerMixin from '@/mixins/AppContainerMixin';
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import DefaultOrValueForm from '@/components/damagecases/forms/DefaultOrValueForm';
import Validate from '@/mixins/Validate';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'ProcessCreateComprehensiveRepairOrder',
	components: { DefaultOrValueForm, ProcessCreatePage, Header, Footer },
	mixins: [AppContainerMixin, Validate],
	data() {
		return {
			defaultValue: this.$t('repair_billing_expertise'),
			model: null,
		};
	},
	methods: {
		warn($event) {
			if ($event === 'custom') {
				this.$swal({
					title: this.$t('sure').toString(),
					text: this.$t('individual_text_hint').toString(),
					icon: 'warning',
					cancelButtonText: this.$t('general.cancel').toString(),
					showCancelButton: true,
				}).then(result => {
					if (!result.value) {
						this.$refs.form.setRadioToDefault();
					}
				});
			}
		},
		continueButtonClick: function(isSkip) {
			if (isSkip) {
				this.$emit('next');
			} else if (this.validate()) {
				this.$store.commit('setProcessCreateComprehensiveRepairOrder', this.model);
				this.$emit('next');
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
};
</script>
